import React from 'react';
import { AvatarImage } from '@/components/ui/avatar';

const clamp = (value, min, max, fallback) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return fallback;
  return Math.min(max, Math.max(min, numeric));
};

export const getAvatarCropStyle = ({ zoom, positionX, positionY } = {}) => ({
  objectFit: 'cover',
  objectPosition: `${clamp(positionX, 0, 100, 50)}% ${clamp(positionY, 0, 100, 50)}%`,
  transform: `scale(${clamp(zoom, 1, 3, 1)})`,
  transformOrigin: 'center',
});

export default function ProfileAvatarImage({
  src,
  alt,
  zoom,
  positionX,
  positionY,
  style,
  ...props
}) {
  return (
    <AvatarImage
      src={src}
      alt={alt}
      style={{ ...getAvatarCropStyle({ zoom, positionX, positionY }), ...style }}
      {...props}
    />
  );
}
